import * as React from "react";
const SvgCrossTiny = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 29, height: 29, viewBox: "0 0 29 29", fill: "none", ...props }, /* @__PURE__ */ React.createElement("g", { style: {
  mixBlendMode: "difference"
}, opacity: 0.3 }, /* @__PURE__ */ React.createElement("path", { d: "M1 1L28.5 28.5M28.5 1L1 28.5" })));
export default SvgCrossTiny;
